import { Component, inject } from "@angular/core";
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";

export interface DiscardPaymentDialogData {
  title?: string;
  message?: string;
  confirmText?: string;
  confirmBtn?: string;
}

@Component({
  selector: "app-discard-payment-dialog",
  templateUrl: "./discard-payment-dialog.component.html",
  styleUrls: ["./discard-payment-dialog.component.css"],
})
export class DiscardPaymentDialogComponent {
  dialogRef = inject(MatDialogRef<DiscardPaymentDialogComponent>);
  data: DiscardPaymentDialogData =
    inject(MAT_DIALOG_DATA, { optional: true }) ?? {};

  get title(): string {
    return this.data?.title ?? "Discard Payment?";
  }

  get message(): string {
    return (
      this.data?.message ??
      "Navigating away will discard the current calculated payment amount."
    );
  }

  get confirmText(): string {
    return this.data?.confirmText ?? "Are you sure you want to discard?";
  }

  get confirmBtn(): string {
    return this.data?.confirmBtn ?? "Yes, Go Back";
  }
}
